










































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Spinner from "@/components/Spinner.vue";
import TOMFragebogenBaustein from "./TOMFragebogen-Baustein.vue";
import TOMFragebogenButtons from "./TOMFragebogen-Buttons.vue";
import TOMFragebogenNummerierung from "./TOMFragebogen-Nummerierung.vue";

@Component({
  components: {
    Spinner,
    TOMFragebogenButtons,
    TOMFragebogenNummerierung,
  },
})
export default class TOMFragebogenUeberschrift2Ordnung extends TOMFragebogenBaustein {}
